export default __webpack_public_path__ + "static/media/caution.287927c1.svg";